/**
 * @module builder
 */
import type { MoveableItem } from '../../index'

export function moveToArchived(item: MoveableItem): any {
  return {
    ...item,
    show: false,
    use_total: false,
    additionalWork: false,
    pending: false
  }
}
